import _ from 'lodash'
import configurazioni from '@/services/configurazioniService'

var menu
(async () => {
  menu = await configurazioni.getConfigurazione('menu')
})()

const elencoVariazioni = () => {
  return menu.variazioni
}

const getVariazione = (categoria, codice) => {
  // TODO: Rivedere gestione variazioni quando elenco effettivo delle lavorazioni
  // eventualente prevedere array lavorazioni
  // Eventualemente filtrare anche per categoria prodotto
  const elenco = menu.variazioni.find(x => x.codice === categoria)
  const variazione = elenco.variazioni.find(x => x.codice === codice)
  return variazione
}

const elencoPreparazioni = () => {
  return menu.preparazioni
}

const usaCategorieVariazioni = () => {
  return menu.impostazioni.usaCategorieVariazioni
}

const categorieVariazioni = () => {
  const catVar = menu.variazioni.map(x => { return { codice: x.codice, descrizione: x.descrizione } })
  var catVariazioni
  if (menu.impostazioni.separaVaziazioniNegative) {
    catVariazioni.push({ codice: 'variazioniMeno', descrizione: menu.impostazioni.labelVariazioniNegative })
    catVariazioni = catVariazioni.concat(_.sortBy(_.uniqBy(catVar, 'codice'), ['codice']))
  } else {
    catVariazioni = _.sortBy(_.uniqBy(catVar, 'codice'), ['codice'])
  }
  catVariazioni.push({ codice: 'preparazioni', descrizione: menu.impostazioni.labelPreparazioni })
  return catVariazioni
}

const elencoVariazioniDisponibiliTab = () => {
  const elenco = {}
  for (const c of categorieVariazioni()) {
    elenco[c.codice] = []
  }
  return elenco
}

/* const elencoMenu = async () => {
  const menu = await configurazioni.getConfigurazione('menu')
  this.elencoVariazioni = menu.variazioni
  this.elencoPreparazioni = menu.preparazioni
  this.impostazioniMenu = menu.impostazioni
  this.menuSceltiAffiancato = menu.impostazioni.menuSceltiAffiancato

  this.usaCategorieVariazioni = menu.impostazioni.usaCategorieVariazioni

  this.separaVaziazioniNegative = menu.impostazioni.separaVaziazioniNegative
  this.labelVariazioniNegative = menu.impostazioni.labelVariazioniNegative
  this.labelPreparazioni = menu.impostazioni.labelPreparazioni

  if (this.usaCategorieVariazioni) {
    const categorieVariazioni = menu.variazioni.map(x => { return { codice: x.codice, descrizione: x.descrizione } })
    if (this.separaVaziazioniNegative) {
      this.categorieVariazioni.push({ codice: 'variazioniMeno', descrizione: this.labelVariazioniNegative })
      this.categorieVariazioni = this.categorieVariazioni.concat(_.sortBy(_.uniqBy(categorieVariazioni, 'codice'), ['codice']))
    } else {
      this.categorieVariazioni = _.sortBy(_.uniqBy(categorieVariazioni, 'codice'), ['codice'])
    }
    this.categorieVariazioni.push({ codice: 'preparazioni', descrizione: this.labelPreparazioni })

    this.elencoVariazioniDisponibiliTab = {}
    for (const c of this.categorieVariazioni) {
      this.elencoVariazioniDisponibiliTab[c.codice] = []
    }
  }
} */

export default {
  elencoVariazioni,
  getVariazione,
  elencoPreparazioni,
  usaCategorieVariazioni,
  categorieVariazioni,
  elencoVariazioniDisponibiliTab
}
